import { lazy } from 'react';

const TextArea = lazy(() => import('./TextArea'));

export { TextArea };
